import React, { useEffect, useState } from 'react';
import '../styles/common.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const VendorForm = ({ userId, companyName, fullName, managementAddress }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const previousData = location.state || {};

  const [plan, setPlan] = useState(previousData.Plan || '');
  const [quoteNo, setQuoteNo] = useState(previousData.QuoteNo || '');
  const [orderID, setOrderID] = useState(previousData.OrderID || '');
  const [type, setType] = useState(previousData.Type || '法人');
  const [company, setCompany] = useState(previousData.CompanyName || '');
  const [buyerName, setBuyerName] = useState(previousData.BuyerName || '');
  const [buyerEmail, setBuyerEmail] = useState(previousData.BuyerEmail || '');
  const [licenseEmail, setLicenseEmail] = useState(previousData.LicenseEmail || '');
  const [selectedProduct, setSelectedProduct] = useState(previousData.ProductName || '');
  const [licenseCount, setLicenseCount] = useState(previousData.LicenseCount || 1);
  const [startDate, setStartDate] = useState(previousData.StartDate || '');
  const [endDate, setEndDate] = useState(previousData.EndDate || '');
  const [errors, setErrors] = useState({});
  const [productList, setProductList] = useState([]);


  useEffect(() => {
    console.log('[VendorForm] 表示された');
    const fetchProductList = async () => {
      try {
        const res = await fetch('https://phfoytnbc1.execute-api.ap-northeast-1.amazonaws.com/ProductStage/get_productlist');
        const data = await res.json();
        setProductList(data);

      } catch (err) {
        console.error('製品一覧取得失敗:', err);
      }
    };
    fetchProductList();
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};
    const today = new Date().toISOString().split('T')[0];

    const todays = new Date();
    const pastLimitDate = new Date(todays);
    pastLimitDate.setDate(todays.getDate() - 30);
    const pastLimitStr = pastLimitDate.toISOString().split('T')[0];

    const validateEmail = (email) => {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };
    const validateOrderID = (value) => {
      if (!value.trim()) return false;
      const regex = /^[A-Za-z0-9\-_.\/ ]+$/;
      return regex.test(value);
    };

    if (!plan) newErrors.plan = 'プランを選択してください';
    if (!quoteNo) newErrors.quoteNo = '見積No.を入力してください';
    if (!orderID) {
      newErrors.orderID = '発注番号を入力してください';
    } else if (!validateOrderID(orderID)) {
      newErrors.orderID = '発注番号は英数字・ - _ . / ・スペースのみ使用できます（空白のみは不可）';
    }
    if (!buyerName) newErrors.buyerName = 'エンドユーザー担当者名を入力してください';
    if (!buyerEmail || !validateEmail(buyerEmail)) {
      newErrors.buyerEmail = 'エンドユーザー担当メールアドレスが正しくありません';
    }
    if (!licenseEmail || !validateEmail(licenseEmail)) {
      newErrors.licenseEmail = 'ライセンス付与メールアドレスが正しくありません';
    }
    if (!selectedProduct) newErrors.productName = '製品名を選択してください';

    if (!licenseCount || isNaN(licenseCount) || licenseCount < 1 || licenseCount > 99) {
      newErrors.licenseCount = 'ライセンス数は1〜99の範囲で指定してください';
    }
    if (!startDate || startDate < pastLimitStr) {
      newErrors.startDate = 'ライセンス開始日は1ヶ月前以降の日付を入力してください';
    }
    if (!endDate || endDate < today) {
      newErrors.endDate = 'ライセンス終了日は今日以降の日付を入力してください';
    }
    if (type === '法人' && !company) {
      newErrors.company = 'エンドユーザー会社名を入力してください';
    }
    if (!selectedProduct) {
      newErrors.productName = '製品名を選択してください';
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      const payload = {
        Plan: plan,
        QuoteNo: quoteNo,
        OrderID: orderID,
        Type: type,
        CompanyName: company,
        BuyerName: buyerName,
        BuyerEmail: buyerEmail,
        LicenseEmail: licenseEmail,
        ProductName: selectedProduct,
        LicenseCount: licenseCount,
        StartDate: startDate,
        EndDate: endDate,
        CreatedAt: today,
        userId: userId,
        companyName: companyName,
        fullName: fullName,
        managementAddress, managementAddress
      };

      console.log("送信データ:", payload);
      navigate('/license/confirm-request', { state: payload });
    }
  };

  return (
    <div className="container">
      <div className="home-button-wrapper">
        <button className="button button-red home-button" onClick={() => navigate('/license')}>
          <img src="/images/home_button_icon.png" className="home-icon" />
        </button>
      </div>

      <h1 className="title">新規申請フォーム</h1>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <label>プラン</label><br />
          <select value={plan} onChange={(e) => setPlan(e.target.value)}>
            <option value="">選択してください</option>
            <option value="トライアル">トライアル</option>
            <option value="正規版">正規版</option>
          </select>
          {errors.plan && <p className="error">{errors.plan}</p>}
          {!errors.plan && <br />}
          {!errors.plan && <br />}

          <label>弊社見積No.</label><br />
          <input
            type="text"
            value={quoteNo}
            onChange={(e) => setQuoteNo(e.target.value)}
          /><br />
          <span className="label-note">※ない場合は【無し】と入力してください。</span>
          {errors.quoteNo && <p className="error">{errors.quoteNo}</p>}
          {!errors.quoteNo && <br />}
          {!errors.quoteNo && <br />}

          <label>発注番号</label><br />
          <input
            type="text"
            value={orderID}
            onChange={(e) => setOrderID(e.target.value)}
          /><br />
          <span className="label-note">※ない場合は0と入力してください。</span>
          {errors.orderID && <p className="error">{errors.orderID}</p>}
          {!errors.orderID && <br />}
          {!errors.orderID && <br />}

          <label>形態</label><br />
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option>法人</option>
            <option>個人</option>
          </select>
          <br /><br />

          {type === '法人' && (
            <>
              <label>エンドユーザー会社名</label><br />
              <input
                type="text"
                value={company}
                onChange={(e) => setCompany(e.target.value)}
              />
              {errors.company && <p className="error">{errors.company}</p>}
              {!errors.company && <br />}
              {!errors.company && <br />}
            </>
          )}

          <label>エンドユーザー担当者名</label><br />
          <input
            type="text"
            value={buyerName}
            onChange={(e) => setBuyerName(e.target.value)}
          />
          {errors.buyerName && <p className="error">{errors.buyerName}</p>}
          {!errors.buyerName && <br />}
          {!errors.buyerName && <br />}

          <label>エンドユーザー担当メールアドレス</label><br />
          <input
            type="email"
            value={buyerEmail}
            onChange={(e) => setBuyerEmail(e.target.value)}
          />
          {errors.buyerEmail && <p className="error">{errors.buyerEmail}</p>}
          {!errors.buyerEmail && <br />}
          {!errors.buyerEmail && <br />}

          <label>ライセンス付与メールアドレス</label><br />
          <input
            type="email"
            value={licenseEmail}
            onChange={(e) => setLicenseEmail(e.target.value)}
          />
          {errors.licenseEmail && <p className="error">{errors.licenseEmail}</p>}
          {!errors.licenseEmail && <br />}
          {!errors.licenseEmail && <br />}

          <label>製品名</label><br />
          <select
            value={selectedProduct}
            onChange={(e) => setSelectedProduct(e.target.value)}
          >
            <option value="">選択してください</option>
            {productList.map((name, idx) => (
              <option key={idx} value={name}>{name}</option>
            ))}
          </select>
          {errors.productName && <p className="error">{errors.productName}</p>}
          {!errors.productName && <br />}
          {!errors.productName && <br />}

          <label>ライセンス数</label><br />
          <input
            type="number"
            min="1"
            value={licenseCount}
            onChange={(e) => setLicenseCount(e.target.value)}
          />
          {errors.licenseCount && <p className="error">{errors.licenseCount}</p>}
          {!errors.licenseCount && <br />}
          {!errors.licenseCount && <br />}

          <label>ライセンス開始日</label><br />
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          {errors.startDate && <p className="error">{errors.startDate}</p>}
          {!errors.startDate && <br />}
          {!errors.startDate && <br />}

          <label>ライセンス終了日</label><br />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          {errors.endDate && <p className="error">{errors.endDate}</p>}
          {!errors.endDate && <br />}
          {!errors.endDate && <br />}

          <button type="submit" className="button button-purple">確認画面へ</button>
        </form>
      </div>

    </div>
  );
};

export default VendorForm;
